/**
 * Authentication Service for Representative Module
 * Handles login, logout, and token management
 */

// Store authentication data
export const loginUser = async ({ token, user, programmes }) => {
  try {
    if (!token || !user) {
      console.error('Missing token or user data');
      return false;
    }

    // Store authentication data
    localStorage.setItem('authToken', token);
    localStorage.setItem('representativeUser', JSON.stringify(user));

    // Store programmes if provided
    if (programmes && programmes.length > 0) {
      localStorage.setItem('programmes', JSON.stringify(programmes));
    }

    // Dispatch custom event for same-tab updates
    // window.dispatchEvent(new Event('repUserDataUpdated'));

    return true;
  } catch (error) {
    console.error('Error storing authentication data:', error);
    return false;
  }
};

// Get authentication token
export const getAuthToken = () => {
  try {
    return localStorage.getItem('authToken');
  } catch (error) {
    console.error('Error retrieving auth token:', error);
    return null;
  }
};

// Get current user from localStorage
export const getCurrentUser = () => {
  try {
    const userStr = localStorage.getItem('representativeUser');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error('Error retrieving user data:', error);
    return null;
  }
};

// Get programmes
export const getProgrammes = () => {
  try {
    const programmesStr = localStorage.getItem('programmes');
    return programmesStr ? JSON.parse(programmesStr) : [];
  } catch (error) {
    console.error('Error retrieving programmes:', error);
    return [];
  }
};

// Get selected programme
export const getSelectedProgramme = () => {
  try {
    const programmeStr = localStorage.getItem('selectedProgramme');
    return programmeStr ? JSON.parse(programmeStr) : null;
  } catch (error) {
    console.error('Error retrieving selected programme:', error);
    return null;
  }
};

// Set selected programme
export const setSelectedProgramme = (programme) => {
  try {
    localStorage.setItem('selectedProgramme', JSON.stringify(programme));
    return true;
  } catch (error) {
    console.error('Error storing selected programme:', error);
    return false;
  }
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = getAuthToken();
  const user = getCurrentUser();
  return !!(token && user);
};

// Logout user
export const logoutUser = async () => {
  try {
    // Clear all authentication data
    localStorage.removeItem('authToken');
    localStorage.removeItem('representativeUser');
    localStorage.removeItem('selectedProgramme');
    localStorage.removeItem('programmes');

    // Dispatch custom event for same-tab updates
    window.dispatchEvent(new Event('repUserDataUpdated'));

    return true;
  } catch (error) {
    console.error('Error during logout:', error);
    return false;
  }
};

export default {
  loginUser,
  getAuthToken,
  getCurrentUser,
  getProgrammes,
  getSelectedProgramme,
  setSelectedProgramme,
  isAuthenticated,
  logoutUser
};